import templateUrl from "emun.customer/customer-list.htm";
import basicController from "servicestack/basic.controller.properties";
import ContactPopup from "emun.customer/customer-contact.popover";
import ShipLocationPopup from "emun.customer/customer-shiplocation.popover";
import customerConfig from "emun.customer/customer.config";
import authConfig from "emun.auth/auth.config";
import customerPicker from "emun.customer/picker/customer-picker";
import ScanBadge from "emun.customer/scan-badge/scan-badge";
import registerRetailerPromptFormIO from "emun.auth/register-retailer.prompt";
import registerRetailerPrompt from "emun.auth/register-retailer-prompt";
import addressValidatorPrompt from "webutils/address-validator-prompt";

class CustomerListController {
	constructor($scope, retailerPrompt) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.showInactive = false;
		$ctrl.prompt = retailerPrompt;
		$ctrl.config = customerConfig;
		$ctrl.authConfig = authConfig;
	}
	$onInit() {
		const $ctrl = this;
		$ctrl.query = $ctrl.container.query;
	}
	load() {
		const $ctrl = this;
		return $ctrl.query.load.apply($ctrl.query, arguments);
	}
	view(customer) {
		const $ctrl = this;
		$ctrl.$state.transitionTo("customer.dashboard", {
			customerId: customer.id
		});
	}
	contactPopup(customer) {
		const $ctrl = this;
		ContactPopup.open({ customer: customer });
	}
	shipLocationPopup(customer) {
		const $ctrl = this;
		ShipLocationPopup.open({ customer: customer });
	}
	toggleInactive() {
		const $ctrl = this;
		if ($ctrl.showInactive) {
			$ctrl.showInactive = false;
			$ctrl.query.criteria.status = "Active";
		} else {
			$ctrl.showInactive = true;
			$ctrl.query.criteria.status = "";
		}
		$ctrl.query.load(true);
	}
	register() {
		const $ctrl = this;
		if ($ctrl.authConfig.formIORegistration) {
			registerRetailerPromptFormIO({});
		} else {
			registerRetailerPrompt({}).then(function (args) {
				$ctrl.$state.go("customer.dashboard", {
					customerId: args.id || args.meta.RetailerId
				});
			});
		}
	}
	create() {
		const $ctrl = this;
		return this.prompt.add().then(function (args) {
			//console.info('customer args', args);
			$ctrl.$state.go("customer.dashboard", {
				customerId: args.id || args.meta.RetailerId
			});
		});
	}
	validateAddress(customer) {
		const $ctrl = this;
		addressValidatorPrompt.open({ model: customer, key: customer.id }).then(function (address) {
			if (address.valid && address.selected) {
				$ctrl.query.bus.send("QueryRetailers.json?Id=" + customer.id).then(function (response) {
					if (response.data.results.length > 0) {
						customer = response.data.results[0];
						customer.companyName = address.selected.companyName;
						customer.address = address.selected.address;
						customer.address2 = address.selected.address2;
						customer.city = address.selected.city;
						customer.state = address.selected.state;
						customer.zip = address.selected.zip;
						customer.tags["latitude"] = address.selected.latitude;
						customer.tags["longitude"] = address.selected.longitude;
						$ctrl.query.bus.send('UpdateRetailer', customer).then(function () {
							$ctrl.query.load(true);
						});
					}
				});
			}
		});
	}
	bulkActions(model) {
		const $ctrl = this;
		return customerPicker({
			title: "Select Customers...",
			view: "table",
			backdrop: false,
			placement: "center",
			criteria: $ctrl.query.criteria
		})
			.finally(() => ($ctrl.query.load(true)));
	}
	scanBadge(model) {
		const $ctrl = this;
		ScanBadge.open({ }).then(() => $ctrl.query.load());
	}
}

export default {
	bindings: {},
	require: {
		container: "^customerContainer"
	},
	controller: CustomerListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
